import * as d3 from "d3";
import "./css/style.less";
import cfg from "./config.json";
import ecoles from "./data/ecoles.json";
import ehdaa from "./data/ehdaa.json";
import { map } from "./components/map.js";
import { list } from "./components/list.js";
import { comparator } from "./components/comparator.js";

//new EventSource("/esbuild").addEventListener("change", () => { location.reload(); });

var data = { config:cfg, ecoles:ecoles, ehdaa:ehdaa };

function init() {
  const sel = d3.select("#viz");
  sel.select("#map-container").call(map, data);
  sel.select("#list").call(list, data);
  sel.select("#comparator").call(comparator, data);

  let lexique = d3.select('.lexique');
  let collapsed = lexique.selectAll(".collapsed").each(function(d, i) {
    d3.select(this).select(".collapse-trigger").on("click", () => {
      d3.select(this).classed("collapsed", ! d3.select(this).classed("collapsed"))
    })
  });

  let comparateurTrigger = document.querySelector('#triggerComparateur');
  let comparateurBtnTrigger = document.querySelector('#triggerBoutonComparateur');
  let comparateurBtn = document.querySelector('#boutonComparateur');
  let comparateur = document.querySelector('#comparateur');

  var elementInView = (el, dividend = 1) => {
    var elementTop = el.getBoundingClientRect().top;
    return (
        elementTop <=
        (window.innerHeight || document.documentElement.clientHeight) / dividend
    );
  };

  var handleScrollAnimation = () => {
    if(elementInView(comparateurTrigger,1)){
      comparateur.classList.remove("minified");
      comparateurBtn.classList.add("visible");
    } else {
      comparateur.classList.add("minified");
      comparateurBtn.classList.remove("visible");
    }
    if(elementInView(comparateurBtnTrigger,1)){
      comparateurBtn.classList.add("minified");
    } else {
      comparateurBtn.classList.remove("minified");
    }
  }

  window.addEventListener("scroll", () => {
    handleScrollAnimation();
  });

  window.addEventListener("load", () => {
    handleScrollAnimation();
  });



  document.querySelector('#scrollToMap').addEventListener("click",(e)=>{
    e.preventDefault();
    const mapContainer = document.querySelector("#carte");
    mapContainer.scrollIntoView({ behavior: "smooth",  inline: "nearest" });
  })
  document.querySelector('#scrollToList').addEventListener("click",(e)=>{
    e.preventDefault();
    const listContainer = document.querySelector("#list");
    listContainer.scrollIntoView({ behavior: "smooth",  inline: "nearest" });
  })
}

init();

